<template>
    <div class="w-full overflow-hidden bg-white mt-4 mb-24 font-poppins">
        <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
        :title="tittle"
        />
        <div v-show="!showModal"> <!-- Primera validación, para saber si quiere ver sus metodos de pago o agregar uno nuevo -->
          <div v-show="!showPayments"> <!-- Segunda validación, para saber si ya tiene metodos de pago a un no-->
            <!-- LOADER -->
            <div v-if="loader_profile" class="fixed inset-0 flex items-center justify-center bg-white  z-50">
              <img
                  src="@/assets/imgs/tuin_loader_v2.gif"
                  alt="cargando..."
                  class=" w-[500px]"
              >
            </div>
            <!-- LOADER -->
            <!-- Sección cuando no tiene métodos de pago registrados -->
            <div v-if="!loader_profile" class="relative">
                <div class="flex items-center justify-center">
                    <div class="p-4">
                        <div class="flex">
                            <div class="self-stretch h-8 justify-center text-black text-lg font-medium font-['Poppins'] leading-snug">
                                Métodos de pago
                            </div>
                        </div>
                        <div class="mt-4 sm:mt-1">
                            <div class=" h-8 justify-center text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">
                                <span>
                                    Parece que aún no registraste una tarjeta. ¿Te gustaría agregar una ahora?
                                </span>   
                            </div>
                        </div>
                        <div class="p-4 flex flex-col items-center">
                            <div class="w-72 h-64 relative overflow-hidden mt-8"> <!-- mt-8 = 2rem = 32px -->
                                <img
                                    src="@/assets/imgs/icons/Home_pagos.svg"
                                    alt="Pagos"
                                    class="w-full h-full object-contain"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div v-if="showPayments"> 
            <!-- LOADER -->
            <div v-if="loader_profile" class="fixed inset-0 flex items-center justify-center bg-white  z-50">
              <img
                  src="@/assets/imgs/tuin_loader_v2.gif"
                  alt="cargando..."
                  class=" w-[500px]"
              >
            </div>
            <!-- LOADER -->
            <!-- Sección para cuando ya registro métodos de pago -->
            <div v-if="!loader_profile" class="relative">
                <div class="flex items-center justify-center">
                    <div class="p-4">
                        <div class="flex">
                            <div class="self-stretch h-8 justify-center text-black text-lg font-medium font-['Poppins'] leading-snug">
                                Métodos de pago
                            </div>
                        </div>
                        <div class="p-4 flex flex-col items-center gap-4">
                            <div class="w-full max-w-[479px] h-32 relative bg-white rounded-lg shadow-[0px_4px_10px_-2px_rgba(0,0,0,0.15)] overflow-hidden">
                              <div class="w-80 left-[55px] top-[16px] absolute inline-flex flex-col justify-start items-start gap-2">
                                <div class="self-stretch h-5 justify-start text-black text-lg font-medium font-['Poppins'] leading-snug">Mastercard con terminación 5642</div>
                                <div class="self-stretch justify-center text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">Expira 10/2027</div>
                              </div>
                              <div class="left-[55px] top-[91px] absolute inline-flex justify-start items-center gap-1.5">
                                <div class="w-16 justify-start text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">Eliminar</div>
                                <div class="w-4 h-0 origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-500"></div>
                                <div class="w-20 justify-start text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">Editar</div>
                              </div>
                              <div class="w-12 h-10 left-[402px] top-[20px] absolute outline-offset-[-1px] overflow-hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="40" viewBox="0 0 52 40" fill="none">
                                  <path d="M9.72011 37.9126V35.2651C9.72011 34.2501 9.10222 33.5883 8.04312 33.5883C7.51367 33.5883 6.94001 33.7648 6.54282 34.3385C6.23408 33.8531 5.79287 33.5883 5.13096 33.5883C4.68955 33.5883 4.24855 33.7206 3.89538 34.206V33.6766H2.96875V37.9126H3.89538V35.5739C3.89538 34.8239 4.29257 34.4708 4.91046 34.4708C5.52795 34.4708 5.83709 34.8679 5.83709 35.5739V37.9126H6.76373V35.5739C6.76373 34.8239 7.20473 34.4708 7.7784 34.4708C8.39629 34.4708 8.70503 34.8679 8.70503 35.5739V37.9126H9.72011ZM23.4429 33.6766H21.9428V32.397H21.0162V33.6766H20.1778V34.5148H21.016V36.4565C21.016 37.4273 21.4132 38.0008 22.4723 38.0008C22.8695 38.0008 23.3105 37.8685 23.6196 37.6921L23.3547 36.8977C23.09 37.0742 22.7812 37.1184 22.5605 37.1184C22.1193 37.1184 21.9428 36.8537 21.9428 36.4123V34.5148H23.4429V33.6766ZM31.2974 33.5881C30.7679 33.5881 30.415 33.8531 30.1943 34.206V33.6766H29.2676V37.9126H30.1943V35.5299C30.1943 34.8239 30.503 34.4267 31.0767 34.4267C31.2532 34.4267 31.4739 34.471 31.6504 34.515L31.9151 33.6326C31.7386 33.5883 31.4739 33.5883 31.2974 33.5883M19.4276 34.0298C18.9862 33.7208 18.3685 33.5885 17.7066 33.5885C16.6477 33.5885 15.9418 34.118 15.9418 34.9564C15.9418 35.6625 16.4713 36.0595 17.3979 36.192L17.8391 36.2362C18.3245 36.3242 18.5893 36.4567 18.5893 36.6774C18.5893 36.9861 18.2363 37.2068 17.6184 37.2068C17.0005 37.2068 16.5153 36.9861 16.2063 36.7656L15.7651 37.4716C16.2506 37.8245 16.9125 38.001 17.5742 38.001C18.8098 38.001 19.5159 37.4275 19.5159 36.6332C19.5159 35.883 18.9422 35.4858 18.0596 35.3536L17.6184 35.3093C17.2212 35.2651 16.9125 35.1771 16.9125 34.9124C16.9125 34.6034 17.2212 34.4269 17.7066 34.4269C18.2363 34.4269 18.7657 34.6474 19.0305 34.7799L19.4276 34.0298ZM44.0498 33.5885C43.5201 33.5885 43.1671 33.8533 42.9464 34.2062V33.6768H42.0198V37.9128H42.9464V35.5301C42.9464 34.8241 43.2554 34.4269 43.8289 34.4269C44.0055 34.4269 44.2262 34.4712 44.4027 34.5152L44.6674 33.6328C44.491 33.5885 44.2262 33.5885 44.0498 33.5885ZM32.224 35.7948C32.224 37.0744 33.1064 38.001 34.4745 38.001C35.0922 38.001 35.5334 37.8687 35.9746 37.5158L35.5334 36.7656C35.1804 37.0304 34.8274 37.1626 34.4303 37.1626C33.6801 37.1626 33.1507 36.6332 33.1507 35.7948C33.1507 35.0006 33.6801 34.471 34.4303 34.4269C34.8274 34.4269 35.1804 34.5592 35.5334 34.8241L35.9746 34.074C35.5334 33.7208 35.0922 33.5885 34.4745 33.5885C33.1064 33.5885 32.224 34.5152 32.224 35.7948ZM40.7844 35.7948V33.6768H39.8578V34.2062C39.5489 33.8092 39.1076 33.5885 38.534 33.5885C37.3426 33.5885 36.416 34.5152 36.416 35.7948C36.416 37.0744 37.3426 38.001 38.534 38.001C39.1517 38.001 39.5931 37.7805 39.8578 37.3833V37.9128H40.7844V35.7948ZM37.3866 35.7948C37.3866 35.0446 37.8721 34.4269 38.6662 34.4269C39.4164 34.4269 39.946 35.0006 39.946 35.7948C39.946 36.5449 39.4164 37.1626 38.6662 37.1626C37.8721 37.1184 37.3866 36.5449 37.3866 35.7948ZM26.3113 33.5885C25.0757 33.5885 24.1931 34.471 24.1931 35.7948C24.1931 37.1186 25.0755 38.001 26.3553 38.001C26.973 38.001 27.5909 37.8245 28.0763 37.4275L27.6349 36.7656C27.2819 37.0304 26.8407 37.2068 26.3995 37.2068C25.8258 37.2068 25.2522 36.9421 25.1197 36.1918H28.2528V35.839C28.297 34.471 27.5028 33.5885 26.3113 33.5885ZM26.3111 34.3827C26.8845 34.3827 27.2819 34.7359 27.37 35.3978H25.1637C25.252 34.8241 25.6492 34.3827 26.3111 34.3827ZM49.3004 35.7948V32H48.3738V34.2062C48.0648 33.8092 47.6236 33.5885 47.05 33.5885C45.8586 33.5885 44.932 34.5152 44.932 35.7948C44.932 37.0744 45.8586 38.001 47.05 38.001C47.6678 38.001 48.1091 37.7805 48.3738 37.3833V37.9128H49.3004V35.7948ZM45.9028 35.7948C45.9028 35.0446 46.388 34.4269 47.1824 34.4269C47.9326 34.4269 48.462 35.0006 48.462 35.7948C48.462 36.5449 47.9326 37.1626 47.1824 37.1626C46.388 37.1184 45.9028 36.5449 45.9028 35.7948ZM14.9265 35.7948V33.6768H13.9999V34.2062C13.691 33.8092 13.2498 33.5885 12.6761 33.5885C11.4847 33.5885 10.5581 34.5152 10.5581 35.7948C10.5581 37.0744 11.4847 38.001 12.6761 38.001C13.294 38.001 13.7352 37.7805 13.9999 37.3833V37.9128H14.9265V35.7948ZM11.4847 35.7948C11.4847 35.0446 11.9702 34.4269 12.7643 34.4269C13.5145 34.4269 14.0441 35.0006 14.0441 35.7948C14.0441 36.5449 13.5145 37.1626 12.7643 37.1626C11.9702 37.1184 11.4847 36.5449 11.4847 35.7948Z" fill="black"/>
                                  <path d="M18.7539 3.39844H32.6534V28.3735H18.7539V3.39844Z" fill="#FF5F00"/>
                                  <path d="M20.1396 16C20.1396 11.2084 22.3431 6.95832 25.73 4.20825C23.241 2.20829 20.0989 1 16.6711 1C8.55028 1 1.98047 7.70823 1.98047 16C1.98047 24.2918 8.55028 31 16.671 31C20.0987 31 23.2408 29.7917 25.73 27.7916C22.3431 25.0833 20.1396 20.7916 20.1396 16Z" fill="#EB001B"/>
                                  <path d="M49.4798 16C49.4798 24.2916 42.91 31 34.7894 31C31.3617 31 28.2197 29.7917 25.7305 27.7916C29.1582 25.0417 31.321 20.7916 31.321 16C31.321 11.2084 29.1173 6.95832 25.7305 4.20825C28.2195 2.20829 31.3617 1 34.7894 1C42.91 1 49.4798 7.74999 49.4798 16Z" fill="#F79E1B"/>
                                </svg>
                              </div>
                        
                            <label class="absolute left-[20px] top-[20px] cursor-pointer">
                              <input type="radio" name="payment" class="peer hidden" />
                              <!-- Estado NO seleccionado -->
                              <div class="rounded-lg outline outline-1 outline-offset-[-0.50px] outline-gray-200 
                                          inline-flex justify-start items-center gap-2 peer-checked:hidden">
                                <div class="w-4 h-4 bg-gray-50 rounded-lg outline outline-[0.50px] outline-gray-300"></div>
                              </div>

                              <!-- Estado SELECCIONADO -->
                              <div class="rounded-lg outline outline-1 outline-offset-[-0.50px] outline-gray-200 
                                          inline-flex justify-start items-center gap-2 hidden peer-checked:inline-flex">
                                <div class="flex justify-center items-center gap-2.5">
                                  <div class="w-4 h-4 bg-gray-50 rounded-full border-4 border-rose-500"></div>
                                </div>
                              </div>
                            </label>
                          </div>
                          <div class="p-4">
                            <div class="w-[479px] h-32 relative bg-white rounded-lg shadow-[0px_4px_10px_-2px_rgba(0,0,0,0.15)] overflow-hidden">
                              <div class="w-80 left-[55px] top-[16px] absolute inline-flex flex-col justify-start items-start gap-2">
                                <div class="self-stretch h-5 justify-start text-black text-lg font-medium font-['Poppins'] leading-snug">Visa con terminación 4561</div>
                                <div class="self-stretch justify-center text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">Expira 09/2030</div>
                              </div>
                              <div class="left-[55px] top-[91px] absolute inline-flex justify-start items-center gap-1.5">
                                <div class="w-16 justify-start text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">Eliminar</div>
                                <div class="w-4 h-0 origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-500"></div>
                                <div class="w-20 justify-start text-neutral-500 text-base font-medium font-['Poppins'] leading-tight">Editar</div>
                              </div>
                              <div class="w-12 h-10 left-[402px] top-[20px] absolute  outline-1 outline-offset-[-1px] ">
                                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="21" viewBox="0 0 64 21" fill="none">
                                  <g clip-path="url(#clip0_3171_61761)">
                                  <path d="M33.0993 6.68466C33.0628 9.59835 35.665 11.2242 37.6253 12.191C39.6393 13.1828 40.3158 13.8188 40.3078 14.7059C40.2928 16.0633 38.7013 16.6624 37.212 16.6857C34.6138 16.7265 33.103 15.9758 31.902 15.408L30.966 19.8405C32.171 20.4025 34.4022 20.8926 36.716 20.9141C42.1472 20.9141 45.7005 18.2008 45.7197 13.9939C45.741 8.65487 38.4228 8.35935 38.4728 5.97294C38.49 5.24933 39.1723 4.47713 40.6673 4.2808C41.4073 4.18162 43.45 4.10571 45.766 5.18506L46.675 0.896508C45.4295 0.437544 43.8288 -0.00193838 41.8358 -0.00193838C36.7238 -0.00193838 33.1283 2.7483 33.0993 6.68466ZM55.4095 0.367459C54.4178 0.367459 53.582 0.952928 53.209 1.85137L45.4507 20.5991H50.878L51.958 17.5784H58.59L59.2165 20.5991H64L59.8257 0.367459H55.4095ZM56.1688 5.83277L57.735 13.43H53.4455L56.1688 5.83277ZM26.519 0.367712L22.241 20.5988H27.4128L31.6887 0.367206L26.519 0.367712ZM18.8682 0.367712L13.4853 14.1379L11.3077 2.42925C11.0522 1.12219 10.0433 0.367459 8.92275 0.367459H0.12325L0 0.954953C1.8065 1.35168 3.859 1.99154 5.1025 2.67619C5.8635 3.09442 6.0805 3.46003 6.3305 4.45386L10.4548 20.5991H15.92L24.299 0.367459L18.8682 0.367712Z" fill="url(#paint0_linear_3171_61761)"/>
                                  </g>
                                  <defs>
                                  <linearGradient id="paint0_linear_3171_61761" x1="2942.34" y1="62.8716" x2="3003.61" y2="-2085.19" gradientUnits="userSpaceOnUse">
                                  <stop stop-color="#222357"/>
                                  <stop offset="1" stop-color="#254AA5"/>
                                  </linearGradient>
                                  <clipPath id="clip0_3171_61761">
                                  <rect width="64" height="21" fill="white"/>
                                  </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <label class="absolute left-[20px] top-[20px] cursor-pointer">
                                <input type="radio" name="payment" class="peer hidden" />

                                <!-- Estado NO seleccionado -->
                                <div class="rounded-lg outline outline-1 outline-offset-[-0.50px] outline-gray-200 
                                            inline-flex justify-start items-center gap-2 peer-checked:hidden">
                                  <div class="w-4 h-4 bg-gray-50 rounded-lg outline outline-[0.50px] outline-gray-300"></div>
                                </div>

                                <!-- Estado SELECCIONADO -->
                                <div class="rounded-lg outline outline-1 outline-offset-[-0.50px] outline-gray-200 
                                            inline-flex justify-start items-center gap-2 hidden peer-checked:inline-flex">
                                  <div class="flex justify-center items-center gap-2.5">
                                    <div class="w-4 h-4 bg-gray-50 rounded-full border-4 border-rose-500"></div>
                                  </div>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <!-- Botón para abrir formulario -->
            <div class="p-4 flex flex-col items-center">
              <fwb-button
                @click="openModalForm"
                :disabled="!isActiveLocation"
                class="w-72 px-5 py-2.5 bg-rose-500 rounded-lg outline outline-1 outline-offset-[-1px] outline-rose-500 inline-flex justify-center items-center gap-2 overflow-hidden disabled:opacity-50 cursor-pointer"
              >
                <div class="w-5 h-5 relative overflow-hidden">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="white" class="w-5 h-5">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.5 5.5C10.7652 5.5 11.0196 5.60536 11.2071 5.79289C11.3946 5.98043 11.5 6.23478 11.5 6.5V9.5H14.5C14.7652 9.5 15.0196 9.60536 15.2071 9.79289C15.3946 9.98043 15.5 10.2348 15.5 10.5C15.5 10.7652 15.3946 11.0196 15.2071 11.2071C15.0196 11.3946 14.7652 11.5 14.5 11.5H11.5V14.5C11.5 14.7652 11.3946 15.0196 11.2071 15.2071C11.0196 15.3946 10.7652 15.5 10.5 15.5C10.2348 15.5 9.98043 15.3946 9.79289 15.2071C9.60536 15.0196 9.5 14.7652 9.5 14.5V11.5H6.5C6.23478 11.5 5.98043 11.3946 5.79289 11.2071C5.60536 11.0196 5.5 10.7652 5.5 10.5C5.5 10.2348 5.60536 9.98043 5.79289 9.79289C5.98043 9.60536 6.23478 9.5 6.5 9.5H9.5V6.5C9.5 6.23478 9.60536 5.98043 9.79289 5.79289C9.98043 5.60536 10.2348 5.5 10.5 5.5Z"
                    />
                  </svg>
                </div>
                <span class="justify-start text-white text-sm font-medium font-['Inter'] leading-tight">
                  Agregar nuevo método de pago
                </span>
              </fwb-button>
            </div>
        </div>
        <div
          v-if="showModal"
          class="fade-in"
        >
          <ModalFormPaymentComponent
            :address="address"
            :export_lat="property_lt"
            :export_ln="property_ln"
            @update-location="handleLocationUpdate"
          />
          <!-- Botón de ubicacion -->
          <div class="flex flex-1 justify-start items-start mt-4 p-2 ml-2">
            <fwb-button
              color="default"
              @click="openModalMaps"
            >
              Regresar a datos de ubicación
            </fwb-button>
          </div>
        </div>
    </div>
      
</template>

<script setup>
import ToastAlert from "@/commond/ToastAlert.vue";
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue';
import ModalFormPaymentComponent from "@/components/payments/FormNewPaymentComponent.vue";

// LLamar a la sesion
import { useStore } from "vuex";
const store = useStore();
let session = computed(() => store.getters.getUserSession);
let birthday = ref();
let step = ref(3);
let showModal = ref(false);
let showPayments = ref(false);
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
let tittle = ref("");
let loader_profile = ref(false);


// Variables para el selector de país y teléfono
const isDropdownOpen = ref(false);

// Configurar CKEditor
function openModalForm() {
  showModal.value = !showModal.value;
}
// Función para cerrar el dropdown cuando se hace clic fuera
const closeDropdown = (e) => {
  const container = document.querySelector('.custom-select-container');
  if (container && !container.contains(e.target)) {
    isDropdownOpen.value = false;
  }
};

//function getProfile() {
//  showPayments.value = !showPayments.value;
//}
onMounted(async () => {
  try {
    loader_profile.value = false;
    //await getProfile();
    //await loadCountryCodes();
    document.addEventListener('click', closeDropdown);
    step.value = session.value.step;
    
    // Verificar si estamos regresando de la verificación OTP
    if (localStorage.getItem('returnToProfile') === 'true') {
      localStorage.removeItem('returnToProfile');
      
    }
  } catch (error) {
    console.error("Error al intentar traer los datos", error);
  }
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdown);
});

watch(birthday, (newValue) => {
  if (newValue === '') {
    birthday.value = null;
  }
});
</script>
<style scoped>
    /* Si el label tiene clases predeterminadas de Flowbite/Tailwind, puedes sobrescribirlas */
    ::v-deep .custom-label label {
    @apply text-white;
    }

    /* También puedes apuntar directamente al selector completo */
    ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
    @apply text-white;
    }
    body {
    background-color: #ffffff !important;
    }

    /* Estilos para el selector de país */
    .custom-select-container {
    position: relative;
    width: 100%;
    }

    .selected-option {
    display: flex;
    align-items: center;
    padding: 0.625rem 1rem;
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    cursor: pointer;
    justify-content: space-between;
    }

    .country-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    }

    .placeholder {
    color: #9ca3af;
    }

    .arrow-down {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #4b5563;
    margin-left: auto;
    }

    .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    z-index: 10;
    margin-top: 0.25rem;
    }

    .country-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    cursor: pointer;
    }

    .country-option:hover {
    background-color: #f3f4f6;
    }

    .flag-img {
    width: 24px;
    height: 16px;
    object-fit: cover;
    }

    .phone-input {
    position: relative;
    }

    .error-message {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.25rem;
    }
</style>
